/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2020-07-31 17:12:15
 */
import baseChart from './customBaseChart'

const parseList = (list, row) => {
  const result = {}
  list && list.filter(item => item.name !== '').forEach((item, index, all) => {
    Object.keys(row || item).forEach(ele => {
      if (!result[ele]) {
        result[ele] = Array(all.length).fill(0)
      }
      result[ele][index] = (item[ele] || 0)
    })
  });

  return result
};

const list2obj = (list) => {
  let result = {}
  list.forEach(item => {
    result[item.xAxis] = item
  })

  return result
}



export default (opt = {}) => {

  let {
    list,
    colorList,
    labelList = []
  } = opt;


  
  if (!colorList) {
    colorList = []
  }

  const colorsStr = colorList.map(item => item.color)

  const result = parseList(list);

  const {name, agreeable, neutrality} = result
  
  
  const barLabel = labelList.filter(item => item.yAxis === '0')
  const lineLabel = labelList.filter(item => item.yAxis !== '0')
  const barMap = list2obj(barLabel)
  const lineMap = list2obj(lineLabel)

  const barList = (agreeable || []).map((item, index) => {
    const x = name[index]
    if (x in barMap) {
      return {
        value: item,
        label: {
          normal: {
            show: true,
            position:'top',
            formatter: barMap[x].label.replace('/s', ' ').replace('/n', '\n')
          }
        }
      }
    }
    return item
  })

  const lineList = (neutrality || []).map((item, index, all) => {
    const x = name[index]
    if (x in lineMap) {
      return {
        value: item,
        label: {
          normal: {
            show: true,
            formatter:  lineMap[x].label.replace('/s', ' ').replace('/n', '\n')
          }
        }
      }
    }
    return item
  })
  
  return Object.assign(baseChart(opt), {
    xAxis: {
      // name: '横坐标',
      type: 'category',
      // boundaryGap: true,
      data: name || [],
      axisLabel: {
        interval: 0,
        rotate: (name || []).length > 15 ? -90 : 0,
      },
      splitLine: {
        show: false
      }
    },
    yAxis: [{
      type: 'value',
      scale: true,
      name: '条形图',
      min: 0,
      splitLine: {
        show: false
      }
    }, {
      type: 'value',
      name: '折线图',
      scale: true,
      min: 0,
      splitLine: {
        show: false
      }
    }],
    series: [{
      type: 'bar',
      name: '条形图',
      itemStyle: {
        normal: {
          color: colorsStr[0] || '#fff'
        },
      },
      label: {
        normal: {
          fontSize: 16,
          color: '#000'
        }
      },
      data: barList
    }, {
      type: 'line',
      name: '折线图',
      // smooth:true,  
      symbolSize: 1,
      // symbol:'none',
      yAxisIndex: 1,
      itemStyle: {
        normal: {
          color: colorsStr[1] || '#fff'
        }
      },
      label: {
        normal: {
          fontSize: 16,
          color: '#000'
        }
      },
      data: lineList
    }]
  })
}



// WEBPACK FOOTER //
// src/chart/multiaxis.js